<template>
  <b-container fluid>
    <b-overlay :show="isLoading">
      <control-list-bar
        @searchChange="newSearch => (searchedText = newSearch)"
      />
      <div id="containlist">
        <template v-if="plagues.length">
          <b-row v-for="plague in filteredPlagues" :key="plague.id">
            <b-col align-self="center">
              <plague-card :plague="plague" />
            </b-col>
          </b-row>
        </template>
        <b-row v-else>
          <b-col cols="12" align-self="center">
            <p class="text-center font-weight-bold bg-light text-uppercase">
              No hay plagas disponibles
            </p>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </b-container>
</template>
<script>
import names from '@/config/names'
import { mapState, mapActions } from 'vuex'
import ControlListBar from '@/components/search/ControlListBar'
import PlagueCard from '@/components/cards/TreatmentPlagueCard'

export default {
  name: 'PlagueList',
  components: {
    PlagueCard,
    ControlListBar,
  },
  data() {
    return {
      searchedText: '',
      names,
      isLoading: true,
    }
  },
  computed: {
    ...mapState('treatments', ['treatmentCreated', 'plagues']),
    filteredPlagues() {
      const filteredPlagues = this.plagues.filter(plague => {
        for (const property in plague) {
          if (
            typeof plague[property] === 'string' &&
            plague[property]
              .toLowerCase()
              .includes(this.searchedText.toLowerCase())
          ) {
            return true
          }
        }
        return false
      })
      // .sort(
      //   (a, b) => new Date(b.fechaaplicacion) - new Date(a.fechaaplicacion)
      // )
      return filteredPlagues
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions('treatments', ['fetchPlagues']),
    loadData: async function () {
      // console.log('En loaddata PLAGUE')
      // await this.fetchPlagues()
      this.isLoading = false
    },
  },
}
</script>

<style scoped>
div#containlist {
  height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}
@media screen and (max-width: 380px) {
  div#containlist {
    height: 450px;
  }
}
</style>
